export default "/assets/015c79939563b990.svg"